import { atob, btoa } from "../utils/utils";

window.atob = atob;
window.btoa = btoa;

// Prototype extensions (use with caution)
String.prototype.format = function () {
    let formatted = this.toString()
    for (const k in arguments) {
        formatted = formatted.replace(new RegExp('\\{' + k + '\\}', 'g'), arguments[k])
    }
    return formatted
}

String.prototype.trimEllip = function (length) {
    const trimmed = this.trim()
    return trimmed.length > length ? trimmed.substring(0, length) + '...' : trimmed
}